import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	boxClass: {
		position: 'absolute' as 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		// width: '90%',
		backgroundColor: useTheme().palette.background.paper,
		borderRadius: useTheme().spacing(2.5),
		padding: useTheme().spacing(2),
	},
	main: {
		flexGrow: 1,
		paddingTop: useTheme().spacing(2),
		paddingBottom: useTheme().spacing(2),
	},
	stackClass: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',
	},
	closeIconClass: {
		top: 10,
		right: 10,
		position: 'absolute',
		borderRadius: 10,
		cursor: 'pointer',
	},
	HeadingClass: {
		paddingLeft: 19,
	},
	grid: {
		paddingLeft: useTheme().spacing(2),
		paddingRight: useTheme().spacing(2),
	},
	customButtonClass: {
		marginTop: useTheme().spacing(2),
		marginBottom: useTheme().spacing(2),
	},
}));

export default styles;
